import { Response } from './utils/providerResponse';
import { post, get } from './api';

export function fetchProfileTariff() {
    return get('tariff/details');
}

export function fetchTariffHistory() {
    return get('tariff/products');
}

export function fetchRecommendProducts() {
    return get('tariff/recommendProducts');
}

export function fetchTariffs() {
    return get('tariff/tariffs').then((res) => {
        const newData = res.data.sort((a, b) => a.ordering - b.ordering);
        return Promise.resolve({
            ...res,
            data: newData,
        });
    });
}

export function fetchProfileRequests() {
    return get('request/requestStatistic').then((res) => {
        const products = res.data.reduce((collection, prod) => {
            collection[prod.productId] = Number(prod.count);

            return collection;
        }, {});

        return Promise.resolve({
            ...res,
            data: products,
        });
    });
}

export function tariffCalculate(products) {
    return post('tariff/recommendByRequests', products);
}

export function subscribe(id) {
    return post('tariff/subscribe', id, 'json').catch((res) => {
        switch (res.status) {
            case 400:
                return Promise.reject({
                    ...res,
                    data: res.data,
                    message: res.data.message,
                });
            default:
                return Promise.reject(res);
        }
    });
}

export function closeTariff() {
    // if (process.env.NODE_ENV === 'development') {
    //     return new Promise((res) => {
    //         setTimeout(() => {
    //             res(new Response());
    //         }, 1000);
    //     })
    // }

    return post('tariff/close', {});
}



// WEBPACK FOOTER //
// ./src/services/api/tariff.js